import {getCookie, getLang, setCookie} from '../../common/Utils';
import Modal from '../modal/Modal';
import { ncBannerOptions} from '../../interface/ICommonbanner';
import { l10nAllLang } from '../../common/L10n';
import { setStartEndDateTime } from '../utils/Utils';
/**
 * @category Commonbanner
 * @description
 * 영상 배너
 * 메인페이지에서만 노출
 * 단, 이미지 레이어가 활성화 되어 있으면 노출 하지 않음
 * 그만보기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 * youtube 인지 CDN 영상인지 체크 후 contents 값 다르게 호출
 */

class MovieLayer {
    isCookieApply: boolean;
    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions, useCookie: boolean) {
        this.isCookieApply = useCookie;

        let thisIsCookieApply = this.isCookieApply && getCookie(_data.movieBanner.Cookie);

        if( !_isMain || !_data.movieBanner.show || thisIsCookieApply || _data.imageBanner.show){
            return;
        }

        if ( _isLauncher && !_data.movieBanner.LauncherShow) {
            return;
        }

        setStartEndDateTime(_data, _data.movieBanner, this.templateMovie.bind(this));

    }

    templateMovie(_data: ncBannerOptions){
        let contents;
        if( _data.movieBanner.CDN) {
            contents = '<video class="video" src="' + _data.movieBanner.URL + '" autoplay controls loop muted></video>';
        } else {
            if(_data.movieBanner.youtubeID != '') {
                contents = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + _data.movieBanner.youtubeID +'?loop=1&playlist=' + _data.movieBanner.youtubeID +'&controls=0&rel=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            } else {
                contents = '<iframe width="100%" height="100%" src="' + _data.movieBanner.URL +'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            }

        }

	    let lang = getLang() || 'en';
        let l10n = l10nAllLang[lang].commonBanner;

        // Shorts 감지: 명시적 옵션 또는 URL 패턴
        const isShorts = _data.movieBanner.isShorts ||
            (_data.movieBanner.URL && _data.movieBanner.URL.indexOf('shorts') > -1);

        let ncBannerModalMovie = new Modal({
            id: 'NC-banner-movie',
            className: isShorts ? 'nc-banner-movie--shorts' : '',
            contents: contents,
            primaryBtnText: l10n.stop_watching,
            cancelBtnText: l10n.close,
            willOpen: ()=>{},
            didClose: (_result: boolean)=>this.addEvents( _result, _data )
        });

        ncBannerModalMovie.open();
    }

    addEvents(_result: boolean, _data: ncBannerOptions){
        const movieBody = document.querySelector('#NC-banner-movie .nc-modal__body');
        if(_result) {
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.movieBanner.Cookie, "true", 100, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.movieBanner.Cookie, "true", 100, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.movieBanner.Cookie, "true", 100, '.plaync.com');
            }
        }
        if(movieBody != undefined){
            movieBody.innerHTML='';
        }
    }

}
export default MovieLayer;
